/*
 * Testimonials pagination dots — indicates item count + current position,
 * and (optionally) jumps by driving the section's prev/next nav buttons.
 * Self-contained: it syncs to Swiper's active-slide class without needing the instance.
 */
(function () {
  function initPagination(section) {
    var dotsWrap = section.querySelector('[data-testimonials-pagination]');
    if (!dotsWrap) return;
    var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.testimonials__pagination-dot'));
    if (dots.length < 2) return;

    var wrapper = section.querySelector('.testimonials__items-wrapper') || section.querySelector('.swiper-wrapper');
    var nextBtn = section.querySelector('.testimonials__navigation-button--next');
    var prevBtn = section.querySelector('.testimonials__navigation-button--prev');
    if (!wrapper) return;

    function activeIndex() {
      var active = wrapper.querySelector('.swiper-slide-active');
      if (!active) return 0;
      var si = active.getAttribute('data-swiper-slide-index');
      if (si !== null) return parseInt(si, 10) || 0;
      var di = active.getAttribute('data-index');
      return di !== null ? (parseInt(di, 10) || 0) : 0;
    }

    function sync() {
      var i = activeIndex();
      for (var k = 0; k < dots.length; k++) {
        dots[k].classList.toggle('is-active', k === i);
      }
    }

    var observer = new MutationObserver(sync);
    observer.observe(wrapper, { attributes: true, attributeFilter: ['class'], subtree: true });

    dots.forEach(function (dot, target) {
      dot.addEventListener('click', function () {
        var steps = target - activeIndex();
        if (!steps) return;
        var btn = steps > 0 ? nextBtn : prevBtn;
        if (!btn) return;
        var remaining = Math.abs(steps);
        (function step() {
          btn.click();
          remaining -= 1;
          if (remaining > 0) setTimeout(step, 70);
          else setTimeout(sync, 70);
        })();
      });
    });

    sync();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-section-type="testimonials"]').forEach(initPagination);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelectorAll) initAll(e.target);
  });
})();
